import gql from 'graphql-tag';

import credentialUpsertFragment from '../fragments/credentialUpsertFragment';

export const mutationUpsertCredentialOAuth = gql`
  mutation upsertCredentialOAuth (
    $code: String!
    $credentialOAuthType: CredentialOAuthType!
    $redirectURI: String!
    $alsoConnectingEmail: Boolean
  ) {
    upsertCredentialOAuth (
      code: $code
      credentialOAuthType: $credentialOAuthType
      redirectURI: $redirectURI
      alsoConnectingEmail: $alsoConnectingEmail
    ) {
      ...credentialUpsertFragment
    }
  }
  ${credentialUpsertFragment}
`;
export default mutationUpsertCredentialOAuth;
